/**
 * Парсер HTML-таблицы из буфера обмена (вставка из Excel / Google Sheets).
 *
 * Берёт ClipboardEvent, извлекает text/html, находит первую <table>,
 * и возвращает строки как string[][].
 *
 * Использование:
 *   const parser = new ClipboardXlsParser(event);
 *   const rows   = parser.rows; // string[][]
 */
class ClipboardXlsParserUtils {
	private _rows: string[][] = [];

	constructor(event: ClipboardEvent) {
		const html      = event.clipboardData?.getData('text/html') ?? '';
		const container = document.createElement('div');

		container.innerHTML = html;

		Array.from(container.children).forEach(child => {
			if (!(child instanceof HTMLTableElement)) return;

			const tbody = child.querySelector('tbody');

			if (!tbody) return;

			tbody.querySelectorAll('tr').forEach(rowEl => {
				const cells = Array.from(rowEl.children).map(
					cellEl => (cellEl as HTMLElement).innerText.trim()
				);

				if (cells.some(cell => cell.length > 0)) {
					this._rows.push(cells);
				}
			});
		});
	}

	get rows(): string[][] {
		return this._rows;
	}

	set rows(value: string[][]) {
		this._rows = value;
	}
}

export default ClipboardXlsParserUtils;
